
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsPromoAvShopGrid extends Serenity.EntityGrid<PsPromoAvShopRow, any> {
        protected getColumnsKey() { return PsPromoAvShopColumns.columnsKey; }
        protected getDialogType() { return PsPromoAvShopDialog; }
        protected getIdProperty() { return PsPromoAvShopRow.idProperty; }
        protected getInsertPermission() { return PsPromoAvShopRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPromoAvShopRow.localTextPrefix; }
        protected getService() { return PsPromoAvShopService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}